export default "__VITE_ASSET__DmoH77Rd__"